import { UAParser } from 'ua-parser-js'

export const isDeviceMobile = () => {
    const parser = UAParser()

    return parser.device.is('mobile')
}
